const ColorConstants = {
  black: "#000405",
  green: "#21eea3",
  white: "#fdfdfd",
  yellow: "#e4d08b",
  red: "#d17778",
  fadedBlack: "#0c1417",
  fadedWhite: "#d1d4d8",
  greenDark: "#0f0f0f",
  background: "#090015"
};

export { ColorConstants };
